// extracted by mini-css-extract-plugin
export default {"card":"J6apePGt","heading":"evFIdgyt","select-lang":"BZcBpSxk","button":"L7g_xcn5"};